export default __webpack_public_path__ + "static/media/prod-error.f0acba65.png";